import {AnimatedFormHelperText} from '@components/@ui';
import {FormGroup} from '@mui/material';
import classNames from 'classnames';
import {FC, PropsWithChildren, ReactNode} from 'react';
import styles from './InputDecorator.module.css';

interface IProps extends PropsWithChildren {
    label: ReactNode;
    helperText?: ReactNode;
    error?: boolean;
    className?: string;
    size?: 'medium' | 'small';
}

export const InputDecorator: FC<IProps> = ({
    children,
    label,
    helperText,
    error,
    className,
    size = 'medium',
}) => {
    return (
        <FormGroup
            className={classNames(styles.decorator, styles[size], className)}
        >
            <div className={styles.container}>
                {children}
                <fieldset
                    className={classNames(styles.fieldset, {
                        [styles.error]: error,
                    })}
                >
                    {label && (
                        <legend className={styles.legend}>{label}</legend>
                    )}
                </fieldset>
            </div>
            <AnimatedFormHelperText helperText={helperText} error={error} />
        </FormGroup>
    );
};
